document.addEventListener("DOMContentLoaded", function () {
  // Find the article content container
  const articleContent = document.querySelector(".article-template__content");
  if (!articleContent) return;

  // Find all h3 elements in the article
  const headings = articleContent.querySelectorAll("h3");
  if (headings.length === 0) return;

  // Create the table of contents container
  const tocContainer = document.querySelector(".toc-container");
  if (!tocContainer) return;

  // Create the TOC heading
  const tocHeading = document.createElement("h3");
  tocHeading.className =
    "font-sans font-medium mb-2.5 lg:mb-5 text-2xl text-[#141414] tracking-[-0.03em]";
  tocHeading.textContent = "Table of Contents";
  tocContainer.appendChild(tocHeading);

  // Create the TOC list container
  const tocList = document.createElement("div");
  tocList.className = "bg-[#6CD3D317] p-5 rounded-lg lg:mb-6";
  const tocUl = document.createElement("ul");
  tocUl.className =
    "list-disc list-inside space-y-2 text-base font-normal font-sans text-black";

  // Process each heading
  headings.forEach((heading, index) => {
    // Generate an ID if not exists
    const headingText = heading.textContent.trim();
    const headingId = heading.id || `section-${index}`;

    // Set ID for the heading if it doesn't have one
    if (!heading.id) {
      heading.id = headingId;
    }

    // Create TOC item
    const li = document.createElement("li");
    const link = document.createElement("a");
    link.href = `#${headingId}`;
    link.className = "hover:text-primary tracking-[-0.03em]";
    link.textContent = headingText;

    // Smooth scroll to section
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const target = document.getElementById(headingId);
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
        // Update URL without page jump
        window.history.pushState(null, null, `#${headingId}`);
      }
    });

    li.appendChild(link);
    tocUl.appendChild(li);
  });

  tocList.appendChild(tocUl);
  tocContainer.appendChild(tocList);
});
